import { ISmartProps } from './types';
import { barLabelStyle, barProgressLargeStyle, barContainerStyle, barStyle } from './styles';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps, HTMLAttrs: any) => {
	const { showLabel, successValue, getProgressLabel, ...rest } = props;
	return {
		Root: {
			props: {
				...getBaseCustomProps(props),
				...rest,
				'data-epo': `epo-progressbar-${meta.version}`,
				'role': `progressbar`,
				part: `epo-progressbar-${meta.version}`,
			},
		},
		BarContainer: {
			style: () => {
				return {
					...barContainerStyle(),
				};
			},
		},
		BarProgress: {
			style: ({ $theme }: any) => {
				const barColor = props.barcolor
					? { backgroundColor: props.barcolor }
					: { backgroundColor: $theme.colors.primary };

				let barSize = props.size === 'large' ? barProgressLargeStyle(props.value, props.showLabel) : {};

				return {
					...barColor,
					...barSize,
				};
			},
		},
		Bar: {
			style: () => {
				return {
					...barStyle(props),
				};
			},
		},
		Label: {
			style: () => {
				return {
					...barLabelStyle(),
				};
			},
		},
	};
};
